export const DEFAULT_STATUS_FILTER = 'All Status'

export const MAX_HISTORY_ROW = 10
export const AUTO_RETRY_TIME = 60000

export const HISTORY_TYPE_LIST = [
  'deposit',
  'withdraw',
  'settlements',
  'funding_fee'
]
export const HISTORY_TYPE_MAP = {
  funding_fee: 'funding fee'
}
export const ASSET_HISTORY_TYPE_LIST = ['DEPOSIT', 'WITHDRAW']
export const SETTLEMENT_HISTORY_TYPE_LIST = ['SETTLEMENTS']
export const FUNDING_FEE_HISTORY_TYPE_LIST = ['FUNDING_FEE']
export const TRANSACTION_STATUS_FILTER_LIST = [
  DEFAULT_STATUS_FILTER,
  'New',
  'Confirm',
  'Processing',
  'Completed',
  'Failed'
]
const ASSET_HISTORY_DATA_COLUMN_LIST = [
  {
    text: 'Asset',
    align: 'left'
  },
  {
    text: 'Quantity',
    align: 'left'
  },
  {
    text: 'Wallet Adderss',
    align: 'left'
  },
  {
    text: 'TxID',
    align: 'left'
  },
  {
    text: 'Status',
    align: 'center'
  },
  {
    text: 'Time',
    align: 'right'
  }
]
const SETTLEMENT_HISTORY_DATA_COLUMN_LIST = [
  {
    text: 'Settled Balance',
    align: 'left'
  },
  {
    text: 'Settled Amount',
    align: 'left'
  },
  {
    text: 'Time',
    align: 'right'
  }
]
const FUNDING_FEE_HISTORY_DATA_COLUMN_LIST = [
  {
    text: 'Market',
    align: 'left'
  },
  {
    text: 'Funding Rate / Annual Rate',
    align: 'left'
  },
  {
    text: 'Status',
    align: 'left'
  },
  {
    text: 'Type',
    align: 'left'
  },
  {
    text: 'Funding',
    align: 'left'
  },
  {
    text: 'Time',
    align: 'right'
  }
]

export const HISTORY_DATA_COLUMN_MAP = {
  DEPOSIT: ASSET_HISTORY_DATA_COLUMN_LIST,
  WITHDRAW: ASSET_HISTORY_DATA_COLUMN_LIST,
  SETTLEMENTS: SETTLEMENT_HISTORY_DATA_COLUMN_LIST,
  FUNDING_FEE: FUNDING_FEE_HISTORY_DATA_COLUMN_LIST
}
